import { render, staticRenderFns } from "./UnassignedClients.vue?vue&type=template&id=5f4037d6&scoped=true&"
import script from "./UnassignedClients.vue?vue&type=script&lang=js&"
export * from "./UnassignedClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4037d6",
  null
  
)

export default component.exports